import { BaseEntity } from 'yt-ng-framework';

export class NacinOtpreme extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string=null;
    Prevoznik: boolean=null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv= input.Naziv;
        this.Prevoznik=input.Prevoznik;
        return this;
    }

    Serialize(input: NacinOtpreme){
        return input;
    }
}